module.exports = __webpack_public_path__ + "static/screen-pushit-4-6bca31906d53dfc9819e5ac08c52199d.jpg";